import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useI18nUrls = () => {
  const { i18n } = useTranslation()

  const { termsUrl, faqUrl, faqArCameraUrl, privacyPolicyUrl } = useMemo(() => {
    if (
      i18n.resolvedLanguage === 'en_US' ||
      i18n.resolvedLanguage === 'ko_KR' ||
      i18n.resolvedLanguage === 'zh_CH' ||
      i18n.resolvedLanguage === 'zh_TW'
    ) {
      return {
        termsUrl: 'https://raund.net/en/terms-en/',
        faqUrl: 'https://raund.net/en/user_qa/',
        faqArCameraUrl: 'https://raund.net/en/user_qa/ar-camera/',
        privacyPolicyUrl: 'https://raund.net/en/privacy-en/',
      }
    }
    // 日本語または言語設定が取得できない場合のfallback
    return {
      termsUrl: 'https://raund.net/terms/?no_layout=true',
      faqUrl: 'https://raund.net/user_qa/?no_layout=true',
      faqArCameraUrl: 'https://raund.net/user_qa/ar_camera/',
      privacyPolicyUrl: 'https://raund.net/privacy/?no_layout=true',
    }
  }, [i18n.resolvedLanguage])

  return { termsUrl, faqUrl, faqArCameraUrl, privacyPolicyUrl }
}
